import { Component, Input, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdamsDocModel } from 'src/app/models/adams-doc-model';

@Component({
  selector: 'app-share-view',
  templateUrl: './share-view.component.html',
  styleUrls: ['./share-view.component.css']
})
export class ShareViewComponent implements OnInit {

  item: AdamsDocModel = {};
  showCopyMsg = false;

  constructor(public dialogRef: DynamicDialogRef, public config: DynamicDialogConfig,
    private clipboardApi: ClipboardService, private msgService: MessageService
  ) {
  }

  ngOnInit(): void {
    this.item = this.config.data;
  }

  copyClipboard() {
    if (this.item.Url) {
      this.clipboardApi.copyFromContent(this.item.Url);
      this.showCopyMsg = true;
      this.msgService.add({ severity: 'success', summary: 'Document Link Copied', detail: 'Document Link Copied to Clipboard' });
    }
  }
}

